<template>
  <div class="business-classes">
    <common-layout>
      <div slot="header">
        <h3>专家人才</h3>
      </div>
      <div slot="container">
        <div class="business-classes.header">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="add"
            style="background: #623aa2; border: none"
          >
            新增
          </el-button>

          <section class="flex-start">
            <span style="width: 5em">姓名</span>
            <el-input
              v-model="value"
              placeholder="请输入要搜索的姓名"
              @keyup.enter.native="search"
              clearable
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </section>
        </div>
        <div class="business-classes.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column type="index" label="序号" align="center" width="90">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="expertName" label="姓名" align="center"></el-table-column>
            <el-table-column
              prop="gender"
              label="性别"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="major"
              label="专业"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="expertCategory"
              label="专家类别"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="expertSource"
              label="专家来源"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="technicalTitle"
              label="技术职称"
              align="center"
              :formatter="formatter"
            ></el-table-column>
            <el-table-column
              prop="region"
              label="所属区域"
              :formatter="formatter"
              align="center"
            ></el-table-column>
            <el-table-column align="left" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  v-show="scope.row.course_status == 4 || !scope.row.enroll_num"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="grid-content bg-purple-light">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next,jumper"
              :total="total"
              :current-page.sync="current_page"
              :page-size="per_page"
            ></el-pagination>
          </div>
        </div>
      </div>
    </common-layout>
    <el-dialog
      title="行业专家"
      :visible.sync="dialogVis"
      width="40%"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="form" :rules="rules" label-width="80px" ref="form">
        <div class="form-title">基本信息</div>
        <el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="专家姓名" prop="expertName">
                <el-input v-model="form.expertName" placeholder="专家姓名"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-col :span="12" class="business-classes.form">
            <el-form-item label="头像">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                name="file"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="form.head" :src="imgUrl + form.head" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-row>
            <el-col :span="12">
              <el-form-item label="性别" prop="gender">
                <el-select v-model="form.gender" style="width: 100%" 　clearable>
                  <el-option
                    v-for="item in sexs"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="专家类别" prop="expertCategory">
                <el-select v-model="form.expertCategory" style="width: 100%" 　clearable>
                  <el-option
                    v-for="item in tech_fields"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="专家来源" prop="expertSource">
                <el-select v-model="form.expertSource" style="width: 100%" clearable>
                  <el-option
                    v-for="item in expertSources"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="12">
            <el-form-item label="专业" prop="major">
              <el-input v-model="form.major" placeholder="专业"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="技术职称" prop="technicalTitle">
              <el-input v-model="form.technicalTitle" placeholder="技术职称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="所属区域" prop="region">
          <el-select v-model="form.region" style="width: 100%" 　clearable :disabled="isHongguUser">
            <el-option
              v-for="item in regionOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="form-title">其他</div>

        <el-form-item label="专家简介" prop="expertProfile">
          <editor
            v-model="form.expertProfile"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
            :placeholderText="'专家简介...'"
          ></editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submitEvent">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../../components/common-layout.vue';
import editor from '../../../components/tinymce-editor/tinymce-editor';

export default {
  components: {
    editor,
    CommonLayout
  },
  data() {
    return {
      tech_field_select: '',
      is_submit: true,
      operate: 'add',
      cur_lives: [
        {
          id: '酒泉市',
          label: '酒泉市'
        },
        {
          id: '嘉峪关市',
          label: '嘉峪关市'
        },
        {
          id: '武威市',
          label: '武威市'
        },
        {
          id: '兰州市',
          label: '兰州市'
        },
        {
          id: '张掖市',
          label: '张掖市'
        },
        {
          id: '金昌市',
          label: '金昌市'
        },
        {
          id: '临夏回族自治州',
          label: '临夏回族自治州'
        },
        {
          id: '定西市',
          label: '定西市'
        },
        {
          id: '庆阳市',
          label: '庆阳市'
        },
        {
          id: '白银市',
          label: '白银市'
        },
        {
          id: '天水市',
          label: '天水市'
        },
        {
          id: '陇南市',
          label: '陇南市'
        },
        {
          id: '甘南藏族自治州',
          label: '甘南藏族自治州'
        },
        {
          id: '平凉市',
          label: '平凉市'
        }
      ],
      sexs: [
        {
          id: '1',
          label: '男'
        },
        {
          id: '2',
          label: '女'
        }
      ],
      tech_fields: [
        {
          id: '1',
          label: '学术类'
        },
        {
          id: '2',
          label: '产业类'
        },
        {
          id: '3',
          label: '管理类'
        },
        {
          id: '4',
          label: '综合类'
        }
      ],
      expertSources: [
        {
          id: '1',
          label: '科技园区'
        },
        {
          id: '2',
          label: '孵化器'
        },
        {
          id: '3',
          label: '产业基地'
        },
        {
          id: '4',
          label: '高校院所'
        },
        {
          id: '5',
          label: '企业'
        }
      ],
      value: '',
      status: '',
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE'
      },
      total: 20,
      current_page: 1,
      per_page: 10,
      dialogVis: false,
      tableData: [],
      form: {
        name: '',
        gender: '',
        head: '',
        major: '',
        expertCategory: '',
        expertName: '',
        expertProfile: '',
        expertSource: '',
        region: '',
        technicalTitle: ''
      },
      rules: {
        expertName: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          }
        ],
        region: [
          {
            message: '请选择所属区域',
            required: true,
            trigger: 'change'
          }
        ],
        major: [
          {
            required: true,
            message: '请填写专业',
            trigger: 'blur'
          }
        ],
        technicalTitle: [
          {
            required: true,
            message: '请填写技术职称',
            trigger: 'blur'
          }
        ],
        gender: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        expertCategory: [
          {
            required: true,
            message: '请选择专家类别',
            trigger: 'change'
          }
        ],
        expertSource: [
          {
            required: true,
            message: '请选择专家来源',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.ResetForm({ value: this.form });
    this.getOptions();
  },
  computed: {
    isHongguUser() {
      try {
        const userInfo = JSON.parse(this.$store.getters.userInfo || '{}');
        return userInfo.username === 'hongguqu' || userInfo.userName === 'hongguqu';
      } catch (e) {
        return false;
      }
    },
    regionOptions() {
      if (this.isHongguUser) {
        return [
          {
            id: '红古区',
            label: '红古区'
          }
        ];
      }
      return this.cur_lives;
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.form.head = res.data.store_result;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG / PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 列表数据回填
    formatter(row, column, cellValue, index) {
      let str = '';
      switch (column.property) {
        case 'gender': {
          str = '';
          if (cellValue == 1) {
            str = '男';
          } else if (cellValue == 2) {
            str = '女';
          }
          return str;
        }
        case 'expertCategory': {
          str = '';
          if (cellValue == 1) {
            str = '学术类';
          } else if (cellValue == 2) {
            str = '产业类';
          } else if (cellValue == 3) {
            str = '管理类';
          } else if (cellValue == 4) {
            str = '综合类';
          }
          return str;
        }
        case 'expertSource': {
          str = '';
          if (cellValue == 1) {
            str = '科技园区';
          } else if (cellValue == 2) {
            str = '孵化器';
          } else if (cellValue == 3) {
            str = '产业基地';
          } else if (cellValue == 4) {
            str = '高校院所';
          } else if (cellValue == 5) {
            str = '企业';
          }
          return str;
        }
        default: {
          return cellValue;
        }
      }
    },
    //   获取下拉选择映射

    async getOptions() {
      try {
        const res = await this.http.get('/industry_expert?keyword&tech_field');
        if (res.data && res.data.sexs) {
          this.sexs = await this.GetOptions(res.data.sexs);
        }
      } catch (e) {}
    },

    search() {
      this.current_page = 1;
      this.getData();
    },
    goPhotoList(row) {
      if (row.course_status != 2) {
        this.$message.warning('只有已结束才能录制课程剪影');
      } else {
        this.$router.push({
          path: `/transfer/business/photo?id=${row.id}`
        });
      }
    },
    add() {
      this.operate = 'add';
      this.dialogVis = true;

      this.$refs['form'].resetFields();
      this.form = this.ResetForm({ type: true, name: 'form' });
      this.applyHongguRegion();
    },
    handleEdit(row) {
      if (this.isHongguUser && row.region !== '红古区') {
        this.$message.warning('红古区分平台只能编辑红古区数据');
        return;
      }
      this.operate = 'edit';
      this.dialogVis = true;
      this.form = Object.assign({}, row);
      this.applyHongguRegion();
    },
    handleDelete(row) {
      if (this.isHongguUser && row.region !== '红古区') {
        this.$message.warning('红古区分平台只能删除红古区数据');
        return;
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          if (row.enroll_num) {
            this.$message.warning('当前课程已有人报名,禁止删除');
            return true;
          }

          this.http
            .request(`/apij2/admin-api/trade/expert-talents/delete?id=${row.id}`, '', 'delete')
            .then(res => {
              if (res.code == 0) {
                this.ResetSearch(['value', 'tech_field_select']);

                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    submitEvent() {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.applyHongguRegion();
      this.$refs['form'].validate(valid => {
        if (valid) {
          const submitForm = this.getSubmitForm();
          if (this.operate == 'add') {
            this.http
              .post('/apij2/admin-api/trade/expert-talents/create', submitForm)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['value', 'tech_field_select']);
                  this.$message.success('新增成功');
                  this.dialogVis = false;
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            this.http
              .post('/apij2/admin-api/trade/expert-talents/update', submitForm)
              .then(res => {
                if (res.code == 0) {
                  this.ResetSearch(['value', 'tech_field_select']);

                  this.$message.success('编辑成功');
                  this.dialogVis = false;
                  //   this.getData("industry_expert");
                  this.search();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;
        }
      });
    },
    close() {
      this.$refs['form'].resetFields();
      this.dialogVis = false;
    },
    applyHongguRegion() {
      if (this.isHongguUser) {
        this.$set(this.form, 'region', '红古区');
      }
    },
    getSubmitForm() {
      const submitForm = Object.assign({}, this.form);
      if (this.isHongguUser) {
        submitForm.region = '红古区';
      }
      return submitForm;
    },
    handleCurrentChange(val) {
      this.getData();
    },
    getData() {
      const params = {
        keyword: this.value,
        page: this.current_page,
        pageSize: this.per_page
      };
      if (this.isHongguUser) {
        params.region = '红古区';
      }
      this.http
        .post('/apij2/admin-api/trade/expert-talents/page', params)
        .then(res => {
          console.log('resresresres', res);
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.per_page = res.data.per_page;
            this.total = res.data.total;
            this.current_page = res.data.current_page;
          } else {
            this.$message.error('获取数据失败！！');
          }
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss">
@include component(business-classes) {
  width: 100%;
  height: 100%;
  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
  @include part(form) {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  }
  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }

    section {
      margin-left: 50px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
    margin-right: 30px;
  }

  @include part(addBtn) {
    margin-left: 30px;
  }

  @include part(table) {
    margin-top: 30px;
  }
}
</style>
